import { ChangeDetectionStrategy, Component } from '@angular/core';
import { faSquare, faTh } from '@fortawesome/free-solid-svg-icons';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { ImageContentState } from '../../state/image-content-state';
import { ImageContentStore } from '../../state/image-content-store';
import { SuperpixelTool } from './superpixel-tool';

@Component({
  selector: 'h3-superpixel-secondary-toolbar',
  templateUrl: './superpixel-secondary-toolbar.component.html',
  styleUrls: ['./superpixel-secondary-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SuperpixelSecondaryToolbarComponent extends AbstractSecondaryToolbar<
  ImageContentState,
  ImageContentStore,
  SuperpixelTool
> {
  faTh = faTh;
  faSquare = faSquare;
}
